import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { PrModalConfirmComponent } from '@app/components/pr-modal/pr-modal-confirm/pr-modal-confirm.component';
import { PrButtonComponent } from '../pr-button/pr-button.component';
import { EaDisplay } from '@app/components/pr-display';

@Component({
    selector: 'pr-button-confirm',
    templateUrl: './pr-button-confirm.component.html',
    styleUrls: ['./pr-button-confirm.component.scss'],
    standalone: false
})
export class PrButtonConfirmComponent
  extends PrButtonComponent
  implements AfterViewInit
{
  @ViewChild(PrModalConfirmComponent, { static: true })
  modal: PrModalConfirmComponent;

  @Input() displayConfirm: EaDisplay;
  @Input() title: string = 'Confirmation';
  @Input() comment: string;
  @Input() labelConfirm: string;
  @Input() labelCancel: string;
  @Input() optionnalLabel: string;
  @Input() displayOptionnal: EaDisplay;
  @Input() modalIcon: string;

  @Output() onConfirm = new EventEmitter<any>();
  @Output() onConfirmOptionnal = new EventEmitter<any>();

  constructor() {
    super();
  }

  ngAfterViewInit(): void {}

  open() {
    this.modal.open();
  }

  confirm() {
    this.onConfirm.emit();
  }

  optionnalConfirm() {
    this.onConfirmOptionnal.emit();
  }
}
